<template>
  <div :class="['lm', state]">
    <div class="lm-top">
      <span class="lm-label">{{ label }}</span>
      <span class="lm-count">{{ countText }}</span>
    </div>
    <div v-if="allowed !== null && allowed !== undefined" class="lm-track" role="progressbar" :aria-label="label"
         :aria-valuenow="used" aria-valuemin="0" :aria-valuemax="allowed">
      <span class="lm-fill" :style="{ width: percent + '%' }"></span>
    </div>
    <p v-if="hint" class="pb-muted lm-hint">{{ hint }}</p>
  </div>
</template>

<script>
export default {
  name: 'LimitMeter',
  props: {
    label: { type: String, required: true },
    used: { type: Number, default: 0 },
    // null means unlimited within fair use.
    allowed: { type: Number, default: null },
    hint: { type: String, default: '' }
  },
  computed: {
    percent() { return this.allowed ? Math.min(100, Math.round((this.used / this.allowed) * 100)) : 0; },
    state() {
      if (this.allowed === null || this.allowed === undefined) return 'open';
      if (this.used > this.allowed) return 'over';
      // A one-of-one allowance (one brand, one form) in use is the plan's normal shape, not a quota running out.
      if (this.used >= this.allowed) return this.allowed <= 1 ? 'single' : 'full';
      return this.percent >= 80 ? 'near' : 'ok';
    },
    countText() {
      if (this.allowed === null || this.allowed === undefined) return this.used + ' · unlimited';
      return this.used + ' / ' + this.allowed;
    }
  }
};
</script>

<style scoped>
.lm{min-width:0}
.lm-top{display:flex;justify-content:space-between;gap:10px;font-size:13.5px;line-height:20px;margin-bottom:6px}
.lm-label{color:#4F4A45}
.lm-count{font-weight:700;color:#1F2328;font-variant-numeric:tabular-nums}
.lm-track{height:8px;border-radius:999px;background:#EDE6DA;overflow:hidden}
.lm-fill{display:block;height:100%;border-radius:inherit;background:#2F7D4F;transition:width .3s ease}
.lm.near .lm-fill{background:#A15C07}
.lm.single .lm-fill{background:#8C8378}
.lm.full .lm-fill,.lm.over .lm-fill{background:#B4472B}
.lm.over .lm-count{color:#B42318}
.lm-hint{margin-top:6px}
</style>
